import { createSelector } from 'reselect'

import { SpecificState } from '../../../types/reduxSaga-deprecated'

export const getVoucherActionsStatusSelector = (voucherId: string) =>
  createSelector(
    (state: SpecificState) => state.inbox.voucherActionStatus,
    (voucherActionStatus) => voucherActionStatus[voucherId],
  )
